import React from 'react'
import './publication.css'

function Volume26no34() {
  return (
    <div className="p-2">
      <section className='content-header d-flex flex-column justify-content-start'>
        <h3 className="p-2" >Vol. 26, Nos. 3&4, Sep 2025</h3>
        <h5 className="p-2">CONTENTS</h5>
            <div className="p-2 contents">
             <a href= '/volume-26-no3&4/Wh-constructionswithoutFocusMarkersAdefabiFO.pdf'><p> Wh-constructions without Focus Markers in S̩úpárè - <strong>Francis Olayinka Adefabi</strong> - 1 </p> </a> 
              </div>
              <div className="p-2">
            <a href= '/volume-26-no3&4/GenreAnalysisofResearchArticleConclusionsFrimpongGKandGyasiRB.pdf'><p>Genre Analysis of Research Article Conclusions in Ghanaian Journals  - 
<strong> George Kodie Frimpong & Rexford Boateng Gyasi </strong> - 18 </p></a> 
              </div>
              <div className="p-2">
              <a href= '/volume-26-no3&4/AntonymicRelationasaTropeofMeaningMaledoORandOgboruLE.pdf'><p>Antonymic Relation as a Trope of Meaning in the Poetry of Tanure Ojaide -  
 <strong>Oliseyenum Richard Maledo & Lawrence Efe Ogboru </strong> - 39 </p></a>
              </div>
               <div className="p-2">
              <a href= '/volume-26-no3&4/SocialMediaSkitCultureandProfessionalArtsEntertainmentOgbodoE.pdf'><p>Social Media Skits Culture and Professional Arts Entertainment in Nigeria -  
 <strong>Edith Ogbodo </strong> - 51 </p></a>
              </div>
            <hr/>
        </section> 
    </div>
  )
}

export default Volume26no34;